// extracted by mini-css-extract-plugin
module.exports = {"footer_control":"viewCriteria_footer_control__2oKFC","content":"viewCriteria_content__3uqGJ","note":"viewCriteria_note__1akes"};